import { render, staticRenderFns } from "./checkPassWord.vue?vue&type=template&id=12988fd9&scoped=true&"
import script from "./checkPassWord.vue?vue&type=script&lang=js&"
export * from "./checkPassWord.vue?vue&type=script&lang=js&"
import style0 from "./checkPassWord.vue?vue&type=style&index=0&id=12988fd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12988fd9",
  null
  
)

export default component.exports